var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnowledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=Knowledge, colour=NeutralDefault, htmlTag=img, assetKey=Content, state=Selected"
  }, /*#__PURE__*/React.createElement("path", {
    id: "school",
    d: "M21.8295 17V10.1L12.8295 15L1.82951 9L12.8295 3L23.8295 9V17H21.8295ZM12.8295 21L5.82951 17.2V12.2L12.8295 16L19.8295 12.2V17.2L12.8295 21Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledge);
export default __webpack_public_path__ + "static/media/Knowledge.5231da3dff6e01e2e5e2d055026623fa.svg";
export { ForwardRef as ReactComponent };